module.exports = __webpack_public_path__ + "img/EnVision.7073b8e6.svg";